import { useRef } from "react";
function t(e) {
  return [e.screenX, e.screenY];
}
function u() {
  let e = useRef([-1, -1]);
  return { wasMoved(r) {
    let n = t(r);
    return e.current[0] === n[0] && e.current[1] === n[1] ? false : (e.current = n, true);
  }, update(r) {
    e.current = t(r);
  } };
}
export {
  u as useTrackedPointer
};
